import {
  PublishParams,
  SongFields,
  SongListParams,
} from "../../view/Modules/Songs/SongDataTypes";
import AxiosInstance from "../config/axiosInterceptor";
import { ContentApiRoutes } from "../../navigation/NavConstant";
import { UtilityServices } from "./UtilityServices";
import { messageTypeArr } from "../config/AppConstants";

export const SongServices = {
  getSongs: (params: SongListParams) => {
    return AxiosInstance.get(ContentApiRoutes.SONGS, { params });
  },
  exportSongs: (params: SongListParams) => {
    return AxiosInstance.get(ContentApiRoutes.EXPORT_SONGS, {
      params,
      responseType: "blob", // important
    })
      .then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "songs-export.xls");
        document.body.appendChild(link);
        link.click();
      })
      .catch((response: any) => {
        UtilityServices.showToaster({
          message: "Some Technical Error Occured or Export Limit Exceeds",
          type: messageTypeArr.error,
        });
      });
  },
  createSong: (data: SongFields) =>
    AxiosInstance.post(ContentApiRoutes.CREATE_SONG, data),
  updateSong: (id: number, data: SongFields) =>
    AxiosInstance.post(
      ContentApiRoutes.UPDATE_SONG.replace(":id", id.toString()) +
        "?_method=PUT",
      data
    ),
  publishSong: (id: number, data: PublishParams) =>
    AxiosInstance.put(
      ContentApiRoutes.PUBLISH_SONG.replace(":id", id.toString()),
      data
    ),

  publishBulkSong: (ids: number[], data: PublishParams) =>
    AxiosInstance.put(ContentApiRoutes.PUBLISH_BULK_SONG, {
      ...data,
      ...{ ids: ids.toString() },
    }),

  deleteSong: (id: number) =>
    AxiosInstance.delete(
      ContentApiRoutes.DELETE_SONG.replace(":id", id.toString())
    ),

  deleteBulkSong: (ids: number[]) => {
    let idl = { ids: ids.toString() };
    return AxiosInstance.put(ContentApiRoutes.DELETE_BULK_SONG, idl);
  },

  viewSong: (id: number) => {
    return AxiosInstance.get(
      ContentApiRoutes.VIEW_SONG.replace(":id", id.toString())
    );
  },

  searchSongs: (song: string) =>
    AxiosInstance.get(ContentApiRoutes.SONGS + `?smart_search=${song}`),

  deleteSongLogo: (id: number) =>
    AxiosInstance.put(
      ContentApiRoutes.DELETE_SONG_LOGO.replace(":id", id.toString())
    ),
};
